<template>
  <div class="site-page site-page--wide nav-content-inset">
    <div class="site-page__inner">
      <h1 class="site-page__title">团队介绍</h1>
      <el-row :gutter="16" class="site-page__grid-row">
        <el-col
          v-for="(member, index) in teamMembers"
          :key="index"
          :xs="24"
          :sm="12"
          :lg="6"
        >
          <el-card class="site-page__team-card" shadow="hover">
            <el-avatar :size="88" :src="member.avatar" />
            <h3>{{ member.name }}</h3>
            <p class="site-page__member-role">{{ member.position }}</p>
            <p class="site-page__member-desc">{{ member.description }}</p>
            <div class="site-page__team-social">
              <el-link
                v-if="member.github"
                :href="member.github"
                target="_blank"
                rel="noopener noreferrer"
              >
                <el-icon><Link /></el-icon>
              </el-link>
            </div>
          </el-card>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { Link } from '@element-plus/icons-vue'

export default {
  name: 'TeamView',
  components: { Link },
  data() {
    return {
      teamMembers: [
        {
          name: 'Peter 宋',
          position: '创始人 & CEO',
          description: '热爱技术，热爱创新，热爱生活。',
          avatar: 'https://picsum.photos/200/200?random=1',
          github: 'https://github.com'
        },
        {
          name: '陈大牛',
          position: 'CTO',
          description: '软件架构和开发专家',
          avatar: 'https://picsum.photos/200/200?random=2',
          github: 'https://github.com'
        },
        {
          name: '陈涛涛',
          position: '首席工程师',
          description: '全栈工程师，10+ 年经验。',
          avatar: 'https://picsum.photos/200/200?random=3',
          github: 'https://github.com'
        },
        {
          name: 'Daisy',
          position: 'UI/UX 设计师',
          description: '专注美观易用的产品体验设计',
          avatar: 'https://picsum.photos/200/200?random=4',
          github: 'https://github.com'
        }
      ]
    }
  }
}
</script>
